module.exports = __webpack_public_path__ + "img/serviceTakeback-step2@2x.24cab2be.png";